/**
 * @fileoverview Shared Category schema used by both frontend and backend.
 */

import { z } from 'zod';
import { createCrudSchemas, createDisplayableEntitySchema, getSchemaFields } from './base.js';
import { ID_PATTERNS } from './types.js';

export const CategorySchema = createDisplayableEntitySchema(
  ID_PATTERNS.CATEGORY,
  'ID must be in ca-prefixed nanoid7 format',
  { accountTracking: 'standard' }
);

const { CreateSchema, UpdateSchema } = createCrudSchemas(CategorySchema);

export const CategoryCreateSchema = CreateSchema;
export const CategoryUpdateSchema = UpdateSchema;

export type Category = z.infer<typeof CategorySchema>;
export type CategoryCreate = z.infer<typeof CategoryCreateSchema>;
export type CategoryUpdate = z.infer<typeof CategoryUpdateSchema>;

export const CATEGORY_FIELDS = getSchemaFields(CategorySchema);
